import React, { useState } from "react";

import ParentPic from "../assets/images/mom&dad2.JPG";
import SisterPic from "../assets/images/Gabbie.JPG";
import Dog1Pic from "../assets/images/Bailey.JPG";
import Dog2Pic from "../assets/images/Poppy.jpeg";

export default function MeetFamily() {
  const family = [
    { name: "Mom & Dad", img: ParentPic },
    { name: "Sister", img: SisterPic },
    { name: "Bailey", img: Dog1Pic },
    { name: "Poppy", img: Dog2Pic },
  ];

  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % family.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + family.length) % family.length);
  };

  return (
    <section className="pt-16 px-6 pb-20 max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold text-yellow-700 text-center mb-4">
        Meet My Family
      </h2>

      <p className="text-center text-gray-700 max-w-2xl mx-auto mb-12">
        Millie has a loving family (and two dog siblings!) who brighten her
        world.
      </p>

      {/* Carousel Container */}
      <div className="relative w-full overflow-hidden">
        {/* Slides Wrapper */}
        <div
          className="flex transition-transform duration-500"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {family.map((member, i) => (
            <div key={i} className="min-w-full flex justify-center">
              <div className="bg-white p-8 rounded-2xl shadow-lg w-96 text-center">
                <div className="w-48 h-48 mx-auto mb-4 rounded-full bg-yellow-100 overflow-hidden shadow-md">
                  <img
                    src={member.img}
                    alt={member.name}
                    loading="lazy"
                    className="w-full h-full object-contain p-2"
                  />
                </div>

                <h3 className="text-xl font-semibold text-yellow-700">
                  {member.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <button
          onClick={prevSlide}
          className="absolute left-2 top-1/2 -translate-y-1/2 bg-yellow-500 hover:bg-yellow-600 text-white p-3 rounded-full shadow-lg"
        >
          ❮
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-yellow-500 hover:bg-yellow-600 text-white p-3 rounded-full shadow-lg"
        >
          ❯
        </button>
      </div>

      {/* Dots Navigation */}
      <div className="flex justify-center mt-6 space-x-2">
        {family.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`w-3 h-3 rounded-full cursor-pointer transition ${
              index === i ? "bg-yellow-600 scale-125" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
    </section>
  );
}
